/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Witty_Drab_Mammoth_FindInputs */

const fr_witty_drab_mammoth_find = /** @type {(inputs: Witty_Drab_Mammoth_FindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Êtes-vous sur de vouloir refuser ce Dropin ? Une fois refusé il ne sera plus possible de le rejoindre.`)
};

/**

* @param {Witty_Drab_Mammoth_FindInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const witty_drab_mammoth_find = /** @type {((inputs?: Witty_Drab_Mammoth_FindInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Witty_Drab_Mammoth_FindInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_witty_drab_mammoth_find(inputs)
});